import withReadOnly from '../ReadOnlyAbilityWrapper';
import TextInput from './TextInput';

export default withReadOnly(TextInput);
